import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { AlertCriticalIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import messages from './messages';

// Function to process markdown-style bold text (**text**)
const processMarkdownText = (text) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      // Remove ** and wrap in strong tag
      const boldText = part.slice(2, -2);
      return <strong key={index}>{boldText}</strong>;
    }
    return part;
  });
};

export default function ResetAffordaPortalApplicationModal({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      status={'warning'}
      icon={<AlertCriticalIcon />}
      title={
        <>
          <Typography
            color={'warning.main'}
            component={'span'}
            sx={{ marginRight: 1, font: 'inherit' }}
          >
            Warning!
          </Typography>{' '}
          Reset Confirmation
        </>
      }
      actionsProps={[
        {
          variant: 'text',
          children: 'Cancel',
          onClick: onClose,
          disabled: isLoading,
        },
        {
          children: 'Confirm & Reset',
          submitButton: true,
          onClick: onConfirm,
          disabled: isLoading,
          isSubmitting: isLoading,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 500,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <Typography variant={'bodyMedium'} display={'block'} paragraph>
        <FormattedMessage {...messages.resetApplicationMessageParagraph1}>
          {(message) => processMarkdownText(message)}
        </FormattedMessage>
      </Typography>

      <Typography variant={'bodyMedium'} display={'block'}>
        <FormattedMessage {...messages.resetApplicationMessageParagraph2}>
          {(message) => processMarkdownText(message)}
        </FormattedMessage>
      </Typography>
    </Modal>
  );
}
